/*eslint-disable*/
import { isRequiredRule, isValidAlphaNumericRule } from "../../../helpers/validators";
import { isSuperAdmin } from "../../../helpers/user";
import i18next from "i18next";

const isValidGroupName = (value) => {
  if (value && !isValidAlphaNumericRule(value)) {
    return { isValid: false, errorMsg: "Special Characters not allowed" };
  }
  return { isValid: true, errorMsg: "" };
};

const groupNameFormatValidator = (groupName, errorMsgs) => {
  const {errorMsg="" } = isValidGroupName(groupName);
  errorMsgs.groupName = errorMsg;
};

const groupNameRequiredValidator = (groupName, errorMsgs) => {
  const { isValid } = isRequiredRule(groupName);
  if (!isValid) errorMsgs.groupName = i18next.t('edit-group-error-group-name');
};

const descriptionRequiredValidator = (group, errorMsgs) => {
  const { isValid } = isRequiredRule(group.description);
  if (!isValid) errorMsgs.description = i18next.t('edit-group-error-description');
};

const applicationRequiredValidator = (group, errorMsgs) => {
  const { isValid } = isRequiredRule(group.application);
  if (!isValid) errorMsgs.application = isSuperAdmin() ? "Search application" :"Select application required.";
};

const groupNameValidator = (group, errorMsgs) => {
  const { groupName, application } = group
  const name = groupName.replace(`${application} - `,"");
  groupNameFormatValidator(name, errorMsgs);
  groupNameRequiredValidator(name, errorMsgs);
};

const descriptionValidator = (group, errorMsgs) => {
  descriptionRequiredValidator(group, errorMsgs);
};

const applicationValidator = (group, errorMsgs) => {
  applicationRequiredValidator(group, errorMsgs);
};


export const validateGroup = (group) => {
  const errorMsgs = {};
  applicationValidator(group, errorMsgs);
  groupNameValidator(group, errorMsgs);
  descriptionValidator(group, errorMsgs);
  return errorMsgs;
};

const FIELD_ID_FORMAT_VALIDATOR = {
  application: applicationValidator,
  groupName: groupNameValidator,
  description: descriptionValidator,
};

export const validateGroupChange = (group, fieldId) => {
  const errorMsgs = {};
  const handler = FIELD_ID_FORMAT_VALIDATOR[fieldId] || noop;
  handler(group, errorMsgs);

  return { ...errorMsgs };
};

